import { DeepLinkScreen } from "../../features/deeplink";

/** FS-11-05-DL 마무리 활동 만들기(Deep Linking) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/deeplink */
export default function DeepLinkPage() {
  return <DeepLinkScreen />;
}
